import Drawable from '../entities/Drawable.js';
import SaveFileOption from '../ui/SaveFileOption.js';
import { getOSM } from '../OverworldAnimation.js';
import VerticalOptionsMenuUI from './VerticalOptionsMenuUI.js';
import YesOrNoMenuUI from './YesOrNoMenuUI.js';

import { c, canvas } from '../setup.js';

export default class SaveFileMenuUI extends Drawable {
    constructor({ position = { x: 0, y: 16 } }) {
        super({ position });

        this.saveFileMenu = getOSM().saveFileMenu;

        this.slot0Option = new SaveFileOption({
            position: {
                x: 0,
                y: this.position.y + 0,
            },
            slotData: this.saveFileMenu.options[0],
        });

        this.slot1Option = new SaveFileOption({
            position: {
                x: 0,
                y: this.position.y + 32,
            },
            slotData: this.saveFileMenu.options[1],
        });

        this.slot2Option = new SaveFileOption({
            position: {
                x: 0,
                y: this.position.y + 64,
            },
            slotData: this.saveFileMenu.options[2],
        });

        this.slot3Option = new SaveFileOption({
            position: {
                x: 0,
                y: this.position.y + 96,
            },
            slotData: this.saveFileMenu.options[3],
        });

        this.visible = true;

        this.saveFileDetailMenuUI = new VerticalOptionsMenuUI({
            menu: this.saveFileMenu.saveFileDetailMenu,
            visible: false,
            position: {
                x: 176,
                y: 96,
            },
        });

        this.yesOrNoMenuUI = new YesOrNoMenuUI({
            menu: this.saveFileMenu.yesOrNoMenu,
            visible: false,
        });
    }

    update() {
        this.slot0Option.update(this.saveFileMenu.options[0]);
        this.slot1Option.update(this.saveFileMenu.options[1]);
        this.slot2Option.update(this.saveFileMenu.options[2]);
        this.slot3Option.update(this.saveFileMenu.options[3]);
    }

    draw() {
        this.update();
        if (!this.visible) {
            return;
        }
        c.fillStyle = 'black';
        c.fillRect(0, 0, canvas.width, canvas.height);
        switch (this.saveFileMenu.currentOption) {
            case 0:
                this.slot0Option.sprite.resetDarkness(1);
                this.slot1Option.sprite.darken(0.5);
                this.slot2Option.sprite.darken(0.5);
                this.slot3Option.sprite.darken(0.5);
                break;
            case 1:
                this.slot0Option.sprite.darken(0.5);
                this.slot1Option.sprite.resetDarkness(1);
                this.slot2Option.sprite.darken(0.5);
                this.slot3Option.sprite.darken(0.5);
                break;
            case 2:
                this.slot0Option.sprite.darken(0.5);
                this.slot1Option.sprite.darken(0.5);
                this.slot2Option.sprite.resetDarkness(1);
                this.slot3Option.sprite.darken(0.5);
                break;
            case 3:
                this.slot0Option.sprite.darken(0.5);
                this.slot1Option.sprite.darken(0.5);
                this.slot2Option.sprite.darken(0.5);
                this.slot3Option.sprite.resetDarkness(1);
                break;
        }
        this.slot0Option.draw();
        this.slot1Option.draw();
        this.slot2Option.draw();
        this.slot3Option.draw();
        this.saveFileDetailMenuUI.draw();
    }
}
